var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextSnippet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9C1.225 9 0.989501 8.902 0.793501 8.706C0.597501 8.51 0.499668 8.27467 0.500001 8V1C0.500001 0.725001 0.598001 0.489501 0.794001 0.293501C0.990001 0.0975008 1.22533 -0.000332484 1.5 8.48897e-07H7L9.5 2.5V8C9.5 8.275 9.402 8.5105 9.206 8.7065C9.01 8.9025 8.77467 9.00034 8.5 9H1.5ZM2.5 7H7.5V6H2.5V7ZM2.5 5H7.5V4H2.5V5ZM6.5 3H8.5L6.5 1V3ZM2.5 3H5V2H2.5V3Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSnippet);
export default __webpack_public_path__ + "static/media/textSnippet.36a6a731bfd686d2a2cccb7532c3de22.svg";
export { ForwardRef as ReactComponent };